"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doFormat = exports.getFormat = void 0;
var getFormat = function (format) {
    switch (format) {
        case 'date':
            return 'YYYY-M-D';
        case 'dateHour':
            return 'YYYY-M-D H';
        case 'dateTime':
            return 'YYYY-M-D H:m';
        case 'time':
            return 'H:m';
        case 'monthYear':
            return 'YYYY-M';
    }
};
exports.getFormat = getFormat;
var doFormat = function (format, moment) {
    return moment.format((0, exports.getFormat)(format));
};
exports.doFormat = doFormat;
//# sourceMappingURL=dateRawFormatter.js.map